/**
 * Mehrsprachigkeit.
 *
 * Der Skill beschreibt `next-intl`; dieses Projekt ist ein Vite-SPA ohne
 * Next.js, deshalb react-i18next. Die Prinzipien bleiben: Gliederung nach
 * Feature, typisierte Schlüssel, ICU-Plurale, Key-Paritätstest.
 *
 * Reihenfolge der Spracherkennung laut Skill: ausdrückliche Wahl (localStorage)
 * → Browsersprache → Quellsprache.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './messages/de.json';
import en from './messages/en.json';

export const SPRACHEN = ['de', 'en'] as const;
export type Sprache = (typeof SPRACHEN)[number];

/** Quellsprache: Hier entstehen neue Texte zuerst. */
export const QUELLSPRACHE: Sprache = 'de';

/** Schlüssel im localStorage — bewusst neben `dockly-theme` einsortiert. */
export const SPRACHE_KEY = 'dockly-sprache';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    fallbackLng: QUELLSPRACHE,
    supportedLngs: SPRACHEN,
    // Nur die Sprache, nicht die Region: „de-AT" soll „de" laden.
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: SPRACHE_KEY,
      caches: ['localStorage'],
    },
    interpolation: {
      // React maskiert bereits — doppeltes Escaping würde Umlaute zerlegen.
      escapeValue: false,
    },
  });

export default i18n;
